module.exports = __webpack_public_path__ + "img/invite-approval-pending.127f63fd.png";